/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import React, { useState } from 'react';
import Element from '../../components/element';
import Text from '../../components/text';
import { ReactComponent as UserSVG } from '../../assets/icons/IconUser.svg';
import { ReactComponent as LogoutSVG } from '../../assets/icons/logout.svg';
import useAuth from '../../root/useAuth';
import Signup from '../../containers/Signup';
import Modal from '../../components/modal';

const Header = ({ user }) => {
  const [showProfileModal, setShowProfileModal] = useState(false);
  const { b2cLogout } = useAuth();

  const toggleProfileModal = () => {
    setShowProfileModal(!showProfileModal);
  };

  return (
    <Element
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      height="96px"
      paddingRight="50px"
      textAlign="right"
    >
      <Element
        display="flex"
        alignItems="center"
        marginRight="35px"
        cursor="pointer"
        attrs={{ onClick: toggleProfileModal }}
      >
        <Element type={UserSVG} width="24px" marginRight="16px" />
        <Text family="GTAR" size="16px">
          {user.email}
        </Text>
      </Element>
      <Element
        display="flex"
        alignItems="center"
        cursor="pointer"
        attrs={{ onClick: b2cLogout }}
      >
        <Element type={LogoutSVG} width="24px" marginRight="16px" />
        <Text family="GTAR" size="16px">
          Log Out
        </Text>
      </Element>
      {showProfileModal && (
        <Modal
          headerLabel="Edit Profile"
          closable
          shouldCloseOnOverlayClick
          preventScroll
          onClose={toggleProfileModal}
        >
          <Signup editable closeModal={toggleProfileModal} />
        </Modal>
      )}
    </Element>
  );
};

export default Header;
